import React, { useState } from 'react';
import PropertyList from '../components/properties/PropertyList';
import WhatsAppButton from '../components/common/WhatsAppButton';
import { getImage } from '../services/ImageService';
import PropertyDetailPage from './PropertyDetailPage';
import './PropertiesPage.css';
export const allProperties = [
    {
        id: 1,
        title: 'Prestige Pine Forest',
        description: 'Luxurious 3-bedroom apartment with stunning city views',
        price: 'Starting at 3.9 CR.',
        image: getImage('1.1'),
        additionalImages: [
            getImage('1.2'),
            getImage('1.1'),
        ],
        location: 'WHITEFIELD, ECC ROAD, BANGLORE 560066',
        propertyType: 'Apartment',
        size: '3&4BHK Flats '
    },
    {
        id: 2,
        title: 'NVT OIKOS',
        description: 'Beautiful 4-bedroom villa with private pool',
        price: 'Starting at 6.5 CR.',
        image: getImage('2.1'),
        additionalImages: [
            getImage('2.2'),
            getImage('2.3'),
            getImage('2.4'),
            getImage('2'),
            getImage('2.1'),
        ],
        location: 'WHITEFIELD, ECC ROAD, BANGLORE 560066',
        propertyType: 'Villa',
        size: '4BHK Duplex Villa '
    },
    {
        id: 3,
        title: 'Prestige Raintree Park',
        description: 'Luxurious 3-bedroom apartment with stunning city views',
        price: 'Starting at 2.95Cr',
        image: getImage('3.1'),
        additionalImages: [
            getImage('3.2'),
            getImage('3.3'),
            getImage('3.4'),
            getImage('3'),
            getImage('3.1'),
        ],
        location: 'WHITEFIELD, VARTUR KODI, BANGLORE 560066',
        propertyType: 'Villa',
        size: '3/4/5 BHK Duplex Villa '
    },
    {
        id: 4,
        title: 'LORVEN CASADE GARDEN',
        description: 'Luxurious 3-bedroom apartment with stunning city views',
        price: 'Starting at 1.39CR.',
        image: getImage('4'),
        additionalImages: [
            getImage('4.1'),
            getImage('4.2'),
            getImage('4'),
            getImage('4.3')
        ],
        location: 'WHITEFIELD, NAGONDANAHALLI, BANGALORE 569966',
        propertyType: 'Apartment',
        size: '3BHK FLATS'
    },
    {
        id: 5,
        title: 'COEVOLVE MISTY SHORES',
        description: 'Industrial-style loft in prime location',
        price: 'Starting at 3.46 CR.',
        image: getImage('5.4'),
        additionalImages: [
            getImage('5.1'),
            getImage('5.2'),
            getImage('5.4'),
            getImage('5')
        ],
        location: 'WHITEFIELD, ITPL ROAD, BANGLORE 560066',
        propertyType: 'Apartment',
        size: '3BHK Flats '
    },
    {
        id: 6,
        title: 'SBR ONE RESIDENCY ',
        description: 'Charming 2-bedroom cottage near the beach',
        price: 'Starting at 1.85CR.',
        image: getImage('6.1'),
        additionalImages: [
            getImage('6.2'),
            getImage('6.3'),
            getImage('6.1'),
            getImage('6')
        ],
        location: 'WHITEFIELD, HOPEFARM, BANGLORE 560066',
        propertyType: 'Apartment',
        size: '2.5/3/3.5/4BHK Flats '
    }
];

const PropertiesPage = () => {
    const [visibleProperties, setVisibleProperties] = useState(3);
    const [selectedProperty, setSelectedProperty] = useState(null);

    const handleViewMore = () => {
        setVisibleProperties(prev => Math.min(prev + 3, allProperties.length));
    };

    const handleSelectProperty = (property) => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
        setSelectedProperty(property);
    };

    const displayedProperties = allProperties.slice(0, visibleProperties);

    if (selectedProperty) {
        // Pass selected property as prop, not via route/params
        return (
            <div className="properties-page">
                <button className="back-button" onClick={() => setSelectedProperty(null)}>
                    ← Back to Properties
                </button>
                <PropertyDetailPage property={selectedProperty} />
            </div>
        );
    }

    return (
        <div className="properties-page">
            <h1>Available Properties</h1>
            <PropertyList properties={displayedProperties} onSelect={handleSelectProperty} />
            {visibleProperties < allProperties.length && (
                <button className="view-more-button" onClick={handleViewMore}>
                    View More Properties
                </button>
            )}
            <WhatsAppButton />
        </div>
    );
};

export default PropertiesPage;